<!-- #735: Notification-Einstellungen. Der Block traegt seinen Abstand selbst (mt-2),
     es gibt in diesem Screen keinen Grid-Rahmen, der seine Kinder gappt. -->
<nx-headline-box
  class="mt-2"
  [label]="'core.user.profile.notifications.headline' | translate">
</nx-headline-box>

<!-- Pruefreihenfolge ist verbindlich: error() VOR loading(). ReactiveContainer setzt loading
     bei einem datenlosen Fehler nie auf false — sonst zeigte die Sektion ewig einen Spinner
     und nie die Fehlerzeile. -->
@if (error()) {
  <div class="bg-white px-5 py-4 text-[#c0123c]">
    {{ 'core.user.profile.notifications.loadErrorMessage' | translate }}
  </div>
} @else if (loading()) {
  <div class="bg-white px-5 py-4 flex flex-row justify-center">
    <p-progressSpinner [style]="{ width: '2rem', height: '2rem' }" strokeWidth="4"></p-progressSpinner>
  </div>
} @else if (isEmpty()) {
  <nx-empty-box
    [label]="'core.user.profile.notifications.emptyMessage' | translate">
  </nx-empty-box>
} @else {

  <!-- Spalten-Kopfzeile: gleiche Flex-Geometrie wie die Row, sonst laufen Kopf und
       Checkboxen auseinander. Nur im Zustand "Fertig".
       Breite: 3 x w-32 (8rem) + w-12 (3rem) = 27rem. -->
  <div class="flex flex-row items-center px-5 py-1 text-base text-[#848488]">
    <div class="grow"></div>
    <div class="min-w-[27rem] flex flex-row items-center justify-end">
      <div class="w-32 flex flex-row justify-center">
        {{ 'core.user.profile.notifications.channels.inApp' | translate }}
      </div>
      <div class="w-32 flex flex-row justify-center">
        {{ 'core.user.profile.notifications.channels.email' | translate }}
      </div>
      <div class="w-32 flex flex-row justify-center">
        {{ 'core.user.profile.notifications.channels.push' | translate }}
      </div>
      <div class="w-12"></div>
    </div>
  </div>

  <!-- Inline-Hinweis fuer Schreibfehler: direkt UNTER der Kopfzeile, damit die Meldung nicht
       die Zeile wegschiebt, deren Checkbox der Nutzer gerade angefasst hat.
       Bleibt stehen, bis der naechste Toggle gelingt. -->
  @if (writeError()) {
    <div class="bg-white px-5 py-2 text-[#c0123c]">
      {{ writeError() | translate }}
    </div>
  }

  <!-- Gruppierung nach categoryLabel. categoryLabel kommt fertig uebersetzt vom Server,
       daher KEINE translate-Pipe darauf. -->
  @for (group of groups(); track group.categoryKey) {
    <div class="px-5 pt-3 pb-1 font-medium">{{ group.categoryLabel }}</div>
    @for (type of group.types; track type.typeKey) {
      <div
        notification-type-row
        [type]="type"
        [locked]="isLocked(type.typeKey)"
        [sendingTest]="isSendingTest(type.typeKey)"
        [canSendTest]="canSendTest"
        (toggled)="onToggle(type, $event)"
        (testRequested)="onSendTest(type)">
      </div>
    }
  }
}
